<template>
  <v-footer app height="auto" class="grey lighten-3">
    <v-spacer></v-spacer>
    <span class="mr-2" v-html="$consts.COPYRIGHT"></span>
  </v-footer>
</template>

<script>
// @group Global Component
export default {};
</script>

<style></style>
